import giftCard from "./en-gift-card.json";
import accountDetails from "./en-account-details.json";
import checkoutForm from "./en-checkout-form.json";
import footer from "./en-footer.json";
import auth from "./en-auth.json";
import hamburgerMenu from "./en-hamburger-menu.json";
import teamGlobal from "./en-team-global.json";

export const en = {
  giftCard,
  accountDetails,
  checkoutForm,
  footer,
  auth,
  hamburgerMenu,
  teamGlobal,
};
